import React from 'react';
import { useSelector } from "react-redux";
import ModalWrapperChildren from '@/views/components/Modal/ModalWrapperChildren';
import api from "@/services/api";

const ModalCloseQuestion = ({setShowModalCloce, showModalClose, handleClose, id, getQuestion, setAlert}) => {
	const { dict } = useSelector(state => state.app);

	const handleCloseQuestion = async () => {
		try {
			const {data} = await api.put(`/questions/${id}/close`);
			if(data) {
				getQuestion(id);
				setAlert({content: dict.simpleTextAdvices.modalClose.alert.closed, variant: 'success'});
				setShowModalCloce(false);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	return (
		<ModalWrapperChildren
			onClose={ handleClose }
			setModalVisible={ setShowModalCloce }
			modalVisible={ showModalClose }
			onConfirm={ handleCloseQuestion }
			closeButtonName={ dict.cancel }
			confirmButtonName={ dict.close  }
			title={ dict.simpleTextAdvices.modalClose.title }
			preTitle={ dict.simpleTextAdvices.modalClose.preTitle }
			description={ dict.simpleTextAdvices.modalClose.description }
		>
		</ModalWrapperChildren>
	);
};

export default ModalCloseQuestion;